import { T } from "@repo/transifex";
import { Switch } from "~/components/Switch";
import { useSuppliersGenerateColors } from "~/hooks/queries/suppliers";
import { DialogError } from "~/components";
import { useUpdateTill } from "~/api/tills/hooks/use-update-till";
import { DisplayErrorMessage } from "~/components/display-error-message";

import { ConfigItem } from "./config-item";

export const ConfigItemProductColors = () => {
  const { mutate: updateTill } = useUpdateTill();
  const {
    mutate: generateColor,
    status: generateColorStatus,
    reset,
    error
  } = useSuppliersGenerateColors();

  return (
    <>
      <ConfigItem
        title={<T _str="Theme" />}
        subtitle={
          <T _str="Our AI analyzes your products and suggests the most suitable colors, making selection quick and intuitive" />
        }
        description={
          generateColorStatus === "pending" ? (
            <T _str="Generating colors may take a moment, please don't close settings" />
          ) : (
            <T _str="Use product colors" />
          )
        }
        allowedTillTypes={["attended", "self-service", "collect"]}
      >
        {(till) => (
          <Switch
            disabled={generateColorStatus === "pending"}
            checked={till.config.hasProductColors}
            handleChange={(checked) => {
              generateColor(
                { hasProductColors: checked },
                {
                  onSuccess: () => {
                    updateTill({
                      hasProductColors: checked
                    });
                  }
                }
              );
            }}
          />
        )}
      </ConfigItem>

      {generateColorStatus === "error" ? (
        <DialogError childrenPosition="top" onOutsideClick={reset}>
          <DisplayErrorMessage error={error} />
        </DialogError>
      ) : null}
    </>
  );
};
